import type { AxiosInstance } from 'axios';

// Query keys must never contain an Axios instance with bearer-token defaults.
const identities = new WeakMap<AxiosInstance, string | number>();
let nextIdentity = 0;
export function identifyClient(client: AxiosInstance, userId: string) {
  // Token rotation must preserve unsaved work; account changes must isolate it.
  identities.set(client, `user:${userId}`);
}

export function clientIdentity(client: AxiosInstance) {
  let id = identities.get(client);
  if (id === undefined) {
    id = ++nextIdentity;
    identities.set(client, id);
  }
  return id;
}
